<template src="../../../../components/shared/contacts/ReadOnlyTemplate.html">
</template>

<script>
    import {api} from "../../../../global/framework/api.js";

    export default {
        name: "ReadOnlyContactModal",
        props: {consultantId: {type: [Number], required: true}},
        data() {
            return {
                fullName: "",
                isViewOnly: false
            };
        },
        methods: {
            async showModal(contactId) {
                this.contactId = contactId;
                //Load contact Info
                let info = await api.getDataWithTwoIds("PsrContact", this.consultantId, "GetContactInfo", contactId);
                this.fullName = info.fullName;
                this.isViewOnly = info.viewOnly;
                this.$refs.modalRef.open();
            },
            async makeViewOnlyContact() {
                let result = await api.post("PsrContact", `${this.consultantId}/UpdateContactViewOnly/${this.contactId}`
                    , {contactId: this.contactId});
                if (result) {
                    this.$refs.modalRef.close();
                    this.$bus.$emit(this.$bus.$AcEvents.CONTACT_CHANGE, result);
                }
            }
        }
    }
</script>

<style scoped>

</style>